<template>
	<div class="tjhb_left_bottom">
		<div class="tjhb_item" @click="goDetail(item.id,1)" v-for="item in list">
			<p class="line-2">{{item.title}}</p>
</div>
	</div>
</template>

<script>
	export default{
		props:{
			list:{
				type:Array|Number,
				default:() => {
					return []
				}
			}
		},
		methods:{
			goDetail(id,flag){
				
			
				this.$emit("goDetail",id,flag)
			}
		}
		
	}
</script>

<style lang="scss" scoped>
	.tjhb_left_bottom{
		flex: 1;
		overflow-y: scroll;
		.tjhb_item{
			margin-top: 0.625rem;
			cursor: pointer;
			border-left: 0.4375rem solid transparent;
			padding: 0.8125rem;
			color: #000;
			font-size: 1.25rem;
			line-height: 1.875rem;
			opacity: 0.8;
			background: rgba($color: #FFFAF4, $alpha: .8)
		}
		.tjhb_item:hover{
			border-left: 0.4375rem solid rgb(255, 240, 213);
			background-color: rgba(228,13,13 , .8);
			color: #fff;
		}
	}
</style>